
      (window.__NEXT_P = window.__NEXT_P || []).push([
        "/",
        function () {
          return require("private-next-pages/index.tsx");
        }
      ]);
    